// Combine class names conditionally
export const classNames = (...classes) => {
  return classes.filter(Boolean).join(' ');
};

// Get character class styling
export const getCharacterClass = (characterClass) => {
  const classStyles = {
    GUERREIRA: 'class-guerreira',
    ASSASSINA: 'class-assassina',
    ARQUEIRA: 'class-arqueira',
    LUTADOR: 'class-lutador',
    PIKE: 'class-pike',
    MECANICO: 'class-mecanico',
    XAMA: 'class-xama',
    SACERDOTISA: 'class-sacerdotisa',
    CAVALEIRO: 'class-cavaleiro',
    MAGO: 'class-mago',
    ATALANTA: 'class-atalanta',
  };
  return classStyles[characterClass] || 'class-guerreira';
};

// Get status styling
export const getStatusClass = (status) => {
  const statusClasses = {
    ACTIVE: 'status-active',
    INACTIVE: 'status-inactive',
    BANNED: 'status-banned',
    SCHEDULED: 'status-scheduled',
    COMPLETED: 'status-completed',
    CANCELLED: 'status-cancelled',
  };
  return statusClasses[status] || 'status-inactive';
};

// Capitalize first letter
export const capitalize = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

// Generate avatar placeholder
export const getAvatarPlaceholder = (name) => {
  if (!name) return 'U';
  return name
    .split(' ')
    .map(word => word.charAt(0))
    .join('')
    .toUpperCase()
    .slice(0, 2);
};

// Truncate text
export const truncateText = (text, maxLength = 100) => {
  if (!text || text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
};